/* global process */
const API_BASE_URL = (process.env.RN_API_BASE_URL || 'https://api.refnow.co').replace(/\/+$/, '');
export const API_URL = `${API_BASE_URL}/v1`;
export const API_URL_V2 = `${API_BASE_URL}/v2`;

//Logo.dev API
// TODO: Replace with your actual Logo.dev public key (starts with pk_)
// Get your key at: https://www.logo.dev/signup
export const LOGO_DEV_API_KEY = 'pk_GG1ymdhBT0y27dM8VTEsUw';

//Referencing
export const GET_CANDIDATE_REFERENCES_URL = '/get/employer/request/';
export const GET_CANDIDATES_URL = '/get/employer/requests';
export const GET_CANDIDATE_REFERENCE_URL = '/get/employer/reference/';
export const GET_EMPLOYER_ACCOUNT = '/get/employer/account';
export const GET_PDF_REPORT_URL = '/get/employer/pdf/request/';
export const GET_PDF_REPORT_URL_V2 = '/get/employer/pdf2/request/';
export const POST_REFERENCE_REQUEST_URL = '/post/employer/request';
export const POST_REFERENCE_REQUEST_REMINDER_URL = '/post/employer/request-notif';
export const POST_CANCEL_REQUEST_REMINDER_URL = '/post/employer/cancel/request';
export const POST_CANCEL_REFEREE_REMINDER_URL = '/post/employer/cancel/reference';
export const POST_SEND_CANDIDATE_REMINDER_URL = '/post/employer/sendreminder/request';
export const POST_SEND_REFEREE_REMINDER_URL = '/post/employer/sendreminder/reference';
export const POST_DELETE_REFERENCE_URL = '/post/employer/delete/reference';
export const POST_EDIT_NUM_OF_REFERENCES_URL = '/post/employer/edit/request-refnum';
export const POST_DELETE_CANDIDATE_URL = '/post/employer/delete/request';
export const POST_ARCHIVE_CANDIDATE_URL = '/post/employer/archive/request';
export const POST_UNARCHIVE_CANDIDATE_URL = '/post/employer/unarchive/request';
export const POST_CANDIDATE_COMMENT_URL = '/post/employer/request-comment/add';
export const GET_TAGS_LIST = '/get/employer/tags/list';
export const POST_ADD_CANDIDATE_TAG_URL = '/post/employer/request-tag/add';
export const POST_REMOVE_CANDIDATE_TAG_URL = '/post/employer/request-tag/remove';
export const POST_CHECK_FOR_EXISTING_REQUEST_EMAIL = '/post/employer/search/requests-by-email';
export const GET_QUESTION_PROFILE_FOR_REQUEST_URL = '/get/employer/request-questions/';
export const GET_REQUEST_SETTINGS_URL = '/get/employer/request-settings/';
export const POST_REQUEST_SETTINGS_URL = '/post/employer/request-settings/';
export const POST_CANCEL_ID_CHECK_URL = '/post/employer/cancel-id-check/';
export const GET_REFEREE_SETTINGS_URL = '/get/employer/referee-settings/';
export const POST_REFEREE_SETTINGS_URL = '/post/employer/referee-settings/';
export const POST_REFERENCE_ARCHIVE_URL = '/post/employer/reference-archive/';
export const POST_REFERENCE_UNARCHIVE_URL = '/post/employer/reference-unarchive/';

//Users and Teams
export const GET_USER_URL = '/get/employer/user/';
export const GET_ADMIN_USERS_URL = '/get/employer/users';
export const GET_TEAMS_URL = '/get/employer/teams';
export const GET_ROLES_URL = '/get/employer/roles';
export const GET_USERS_FOR_FILTERS_URL = '/get/employer/request-filter/users';
export const GET_TEAMS_FOR_FILTERS_URL = '/get/employer/request-filter/teams';
export const POST_CREATE_NEW_USER_URL = '/post/employer/user/add';
export const POST_ADMIN_USER_UPDATE_URL = '/post/employer/user/update';
export const POST_ADMIN_USER_DELETE_URL = '/post/employer/user/delete';
export const POST_ADMIN_TEAM_UPDATE_URL = '/post/employer/team/update';
export const POST_ADMIN_TEAM_DELETE_URL = '/post/employer/team/delete';
export const POST_CREATE_NEW_TEAM_URL = '/post/employer/team/add';

//Login and Registration
export const POST_LOGIN_URL = '/post/employer/login';
export const POST_LOGOUT_URL = '/post/employer/logout';
export const POST_SSO_LOGIN_URL = '/post/employer/auth/check-sso';
export const POST_ACTIVATION_URL = '/post/employer/activate';
export const POST_REGISTER_URL = '/post/employer/signup';

//Intercom (served from the v2 API — use with API_URL_V2)
export const GET_INTERCOM_MESSENGER_JWT = '/get/employer/intercom/messenger-jwt';

//Subscriptions & Billing
export const GET_SUBSCRIPTION = '/get/subscription';
export const POST_SUBSCRIPTION = '/post/payment/subscription';
export const GET_TOP_UP_DETAILS = '/get/subscription/topup';
export const POST_TOP_UP_PAYMENT = '/post/payment/topup';

//Question Profiles
export const GET_QUESTION_PROFILES_URL = '/get/employer/questionprofiles';
export const GET_QUESTION_PROFILE_URL = '/get/employer/questionprofile/';
export const GET_QUESTION_PROFILE_PREVIEW_URL = '/get/employer/questionprofile/';
export const GET_QUESTION_PROFILE_SETTINGS_URL = '/get/employer/settings/questionprofile/';
export const POST_QUESTION_PROFILE_SETTINGS_URL = '/post/employer/settings/questionprofile/';
export const POST_QUESTION_PROFILE_URL = '/post/employer/questionprofile/add';
export const DELETE_QUESTION_URL = '/post/employer/question/delete';
export const POST_NEW_QUESTION_URL = '/post/employer/question/add';
export const POST_EDIT_QUESTION_URL = '/post/employer/question/edit';
export const GET_PROFILES_LIST_URL = '/get/employer/profiles/list';
export const DELETE_PROFILE_URL = '/post/employer/questionprofile/delete';
export const REORDER_QUESTIONS_URL = '/post/employer/questionprofile/reorder';
export const POST_CLONE_PROFILE_URL = '/post/employer/questionprofile/clone';

//Talent Pool
export const GET_TALENT_POOL_LIST = '/get/employer/pool/talent/list';
export const GET_TALENT_POOL_LIST_WITH_STATS = '/get/employer/pool/talent/list-with-stats';
export const GET_TALENT_POOL_FILTERS = '/get/employer/pool/talent/filters';
export const POST_TALENT_POOL_DELETE = '/post/employer/pool/talent/delete';
export const GET_VACANCY_POOL_LIST = '/get/employer/pool/vacancy/list';
export const POST_VACANCY_POOL_DELETE = '/post/employer/pool/vacancy/delete';

//Settings
export const GET_USER_SETTINGS = '/get/employer/settings/user/myaccount';
export const GET_NOTIFICATION_SETTINGS = '/get/employer/settings/user/notification/emails';
export const POST_USER_SETTINGS = '/post/employer/settings/user/myaccount';
export const POST_PASSWORD_RESET = '/post/employer/password/reminder';
export const POST_NOTIFICATION_SETTINGS = '/post/employer/settings/user/notification/emails';
export const POST_ORGANISATION_NAME_URL = '/post/employer/org/update';
export const POST_CREATE_TAG_URL = '/post/employer/org-tag/create';
export const POST_DELETE_TAG_URL = '/post/employer/org-tag/delete';
export const POST_ORG_LOGO_UPLOAD_URL = '/post/employer/org/logo/upload';
export const POST_ORG_LOGO_DELETE_URL = '/post/employer/org/logo/delete';
export const POST_ORG_CUSTOM_COLORS_URL = '/post/employer/org/custom-colors';

//Two-Factor Authentication (2FA)
export const GET_2FA_STATUS = '/get/employer/settings/user/2fa';
export const POST_2FA_SETUP = '/post/employer/settings/user/2fa/setup';
export const POST_2FA_ENABLE = '/post/employer/settings/user/2fa/enable';
export const POST_2FA_DISABLE = '/post/employer/settings/user/2fa/disable';
export const POST_RESET_USER_2FA = '/post/employer/user/reset-2fa';

//Inbound
// export const GET_INBOUND_DASHBOARD_STATS = 'get/employer/inbound/dashboard?date_filter_days=10000';
export const GET_INBOUND_DASHBOARD_STATS_URL = '/get/employer/inbound/dashboard';

//Referencing Dashboard
export const GET_REFERENCING_DASHBOARD_STATS_URL = '/get/employer/referencing/dashboard';

// Reporting (candidate summary & fraud detection)
export const GET_REPORTING_CANDIDATE_SUMMARY = '/get/employer/reporting/candidate-summary';
export const GET_REPORTING_FRAUD_DETECTION = '/get/employer/reporting/fraud-detection';

//Candidate Forms
export const GET_CANDIDATE_FORM_DETAILS_URL = '/get/referee/basic';
export const POST_CANDIDATE_DRAFT_DATA = '/post/request/draft-data';
export const POST_NEW_REFERENCE = '/post/referee/add';
export const POST_NEW_GAP = '/post/referee/add-gap';
export const POST_REFEREE_VERIFY_DETAILS = '/post/referee/add-verify-details';
export const POST_CHANGE_REFEREE_EMAIL = '/post/request/change-referee-email';
export const POST_DELETE_REFEREE = '/post/request/delete-referee';
export const POST_DECLINE_REQUEST = '/post/request/decline';
export const POST_NI_DOB = '/post/request/ni-dob';
export const POST_SHARE_CODE = '/post/request/sharecode';
export const POST_CAN_QUESTIONS = '/post/request/can-questions';

//Reference (referee-facing) Forms
export const GET_REFERENCE_FORM_DETAILS_URL = '/get/reference/basic';
export const POST_REFERENCE_CONFIRM_DETAILS = '/post/reference/update-confirmed';
export const POST_REFERENCE_UPDATE_DETAILS = '/post/reference/update';
export const POST_REFERENCE_ABOUT_YOU = '/post/reference/step2';
export const POST_REFERENCE_ANSWERS = '/post/reference/step3';
export const POST_REFERENCE_POOLS = '/post/reference/step-pools';
export const POST_REFERENCE_DECLINE = '/post/reference/decline';
export const POST_REFERENCE_FILE_UPLOAD = '/post/reference/file-upload';
